import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import CardMachine from "../../Components/cardMachine/cardMachineOrigin";
import "./dashboard.css";
import Api from "../../services/api";
import Alert from "../../Components/alert/Alert";
import { Redirect } from "react-router";
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import Select from '../../Components/select/select';
import {faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Main extends React.Component {
  state = {
    loading: true,
    machines: [],
    machinesSelect: [{value: "Todos", label: "Todos"}],
    show: false,
    machinesInitial: [],
    message: "",
    departments: [{ value: "Todos",label:"Todos"}],
    status: [{value: "Todos", label:"Todos"},{value: null, label: "Máquina desligada"},{value: true, label: "Máquina produzindo"},{value: false, label: "Máquina parada"},{value: 2, label: "Sem Operador"},{value: 3, label: "Parada programada"}],
    status_id: [{value: "Todos", label:"Todos"},{value: null, label: "Máquina desligada"},{value: true, label: "Máquina produzindo"},{value: false, label: "Máquina parada"},{value: 2, label: "Sem Operador"},{value: 3, label: "Parada programada"}],
    departments_id: [],
    Dashboard: true,
    messageDash: "Nenhuma máquina em monitoramento para este setor.",
    redirect: false,
    reload: false,
    ToastArray: [],
    factorys: [{ value: "Todos",label:"Todos"}],
    id_factorys: [],
    filterArr: [],
    height:'',
    width:'',
    changed:false,
    dash:false
  };

  async componentDidMount() {
    let departments = [];
    
    await this.getAllMachines();

    await Api.get("/factorys/").then((response) => {
      let arr = [];
      response.data.forEach((element) => {
        arr.push({ value: element.description,label:element.description});
      });
      this.state.factorys.push(...arr);
      this.setState({ id_factorys: [...response.data] });
    });

    await Api.get("/departments/")
      .then((resp) => {
        //console.log(resp);
        this.state.departments.push(...departments);
        this.setState({ departments_id: resp.data });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          message: "Erro de conexão com o servidor.",
          show: true,
          reload: true,
        });
      });


      //Função para atualizar a cada 5 minutos a página de dashboard.
      setInterval(()=>{
        window.location.reload();
      }, 300000)
      
  }

  getAllMachines = () => {
    
    Api.get("/track-machines/list/")
      .then((response) => {
        console.log(response)
        if (response.data.error !== undefined) {
          alert(JSON.stringify(response.data.error));
        } else {
          if (response.data.length === 0 || response.status == 205) {
            
            this.setState({
              Dashboard: false,
              dash:true,
              messageDash: "Nenhuma máquina ou turno ativo.",
              loading: false
            });
          } else {
              let machines = [];

              response.data.sort(function(a,b){
                if(a.statusData.status == true && b.statusData.status == 2){
                  return -1;
                }
                if(a.statusData.status < b.statusData.status){
                  return 1;
                }
                if(a.statusData.status > b.statusData.status){
                  return -1;
                }
                if(a.statusData.status == false && b.statusData.status == null){
                  return -1;
                }
                return 0;
              });

              response.data.forEach((element)=>{
              machines.push({value: element.id, label: element.description + element.code});
              });
              
              
            this.setState({
              machines: response.data,
              machinesSelect: machines,
              machinesInitial: response.data,
              Dashboard: true,
              dash:true,
              loading:false
            });


          }
        }
      })
      .catch((error) => {
        this.setState({
          message: "Erro de conexão com o servidor.",
          show: true,
          Dashboard: false,
          showModalLoad: false,
          reload: true,
          loading: false
        });
      });
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };
  notifyAction = (value) => {
    this.setState({ ToastArray: [...this.state.ToastArray, value] });
  };
  callbackfunctionload = () => {
    this.setState({ showModalLoad: false });
  };

  callBackDepartment = (child) => {
    if (child.trim() === "Todos") {
      this.setState({ machines: this.state.filterArr });
      this.setLoading(true);
      this.setState({machines: []});
      setTimeout(()=>{
        this.setState(
          { machines: this.state.filterArr, loading: false }
        );
      },1000)
    }
    else{
      const { id } = this.state.departments_id.find(
        (e) => e.description === child
      );

      let resultArray = this.state.machinesInitial.filter(
        (v) => v.id_department === id
      );
      this.setLoading(true);
      this.setState({machines: []});
      setTimeout(()=>{
        this.setState(
          { machines: resultArray, filterArr: resultArray, loading: false }
        );
      },1000)
    }
    if(this.state.changed){
      this.setLoading(true);
      this.setState({machines: []});
      setTimeout(()=>{
        this.setState(
          { machines:this.state.machinesInitial, changed:false, filterArr: resultArray, loading: false }
        );
      },1000)
    }
  };

  callBackFactory = (value) => {
    if (value.trim() === "Todos") {
      this.setState({ machines: this.state.machinesInitial,
      departments: [{ value: "Todos",label:"Todos"}], changed:true });
    } else {
      let arrAux = [];
      const { id } = this.state.id_factorys.find(
        (e) => e.description === value
      );
      let resultArray = this.state.machinesInitial.filter(
        (v) => v.id_factory === id
      );
      this.setLoading(true);
      this.setState({machines: []});
      setTimeout(()=>{
        this.setState(
          { machines: resultArray, filterArr: resultArray, loading: false }
        );
      },1000)
      
      if(this.state.changed){
        this.setState({ machines:this.state.machinesInitial, changed:false})
      }
      if (
        resultArray.length > 0 ||
        resultArray !== null ||
        resultArray !== undefined ||
        resultArray.length > 0 ||
        resultArray !== ""
      ) {
        const arrFilter = this.state.departments_id.filter(
          (e) => e.id_factory === id
        );
        arrAux.push({ value: "Todos",label:"Todos"});
        arrFilter.forEach((element) => {
          arrAux.push({ value: element.description,label:element.description});
        });
        this.setState({ departments: arrAux });
      } else {
        null;
      }
    }
  };


  setLoading = (status) =>{
    this.setState({loading: status})
  }

  callBackStatus = (value) => {
      this.setLoading(true);
      this.setState({machines: []});
    if (value === "Todos") {
      setTimeout(()=>{
        this.setState({ machines: this.state.machinesInitial,
          status: [{value: "Todos", label:"Todos"},{value: null, label: "Máquina desligada"},{value: true, label: "Máquina produzindo"},{value:false, label: "Máquina parada"},{value: 2, label: "Sem Operador"},{value: 3, label: "Parada programada"}], changed:true, loading: false });
      },1000)
      
    } else {
      
      setTimeout(()=>{
        this.setLoading(false);
        let arrAux = [];
      this.state.machinesInitial.forEach(e => {if(e.statusData.status == value){
        arrAux.push(e)
      }});
      this.setState({ machines: arrAux,
        status: [{value: "Todos", label:"Todos"},{value: null, label: "Máquina desligada"},{value: true, label: "Máquina produzindo"},{value: false, label: "Máquina parada"},{value: 2, label: "Sem Operador"},{value: 3, label: "Parada programada"}], changed:true, loading: false }); 
      },1000)
      
    }
  };

  callBackMachines = (value) =>{
    let machine = document.getElementById(value);
    if(machine != null){
      machine.scrollIntoView();
      machine.className = "activeMachine";
      setTimeout(()=>{
        machine.className = "";
      },4000)
    }else{
      this.setState({
          message: "Máquina não encontrada.",
          show: true,
          reload: false,
        });
    }
  }

  openCaptions = (status) => {
    let caption = document.getElementById("caption");
    switch(status){
      case "open":
        caption.style.display = "initial";
      break;
      case "close":
        caption.style.display = "none";
      break;
      default:
        caption.style.display = "none";
    }
    
  };




  render() {
    const { show, message, Dashboard, loading, redirect, reload } =
      this.state;

    if (redirect) return <Redirect to="/"/>
    
    return (
      <>
        <header>
          <Top_bar />
          
          {show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
              reload={reload}
              onload
            />
          ) : null}
        </header>
        <main>
          <div className="top-line">
            <div className="titleMachine">Painel de Máquinas <FontAwesomeIcon size={"1x"} icon={faInfoCircle} onMouseEnter={() => this.openCaptions("open")} onMouseLeave={() => this.openCaptions("close")} /></div>
            <div className="lineDrops">
              <div>
                <Select
                    autoSelect={false}
                    label="Parque Fabril"
                    arrData={this.state.factorys}
                    handleSelect={this.callBackFactory}
                />
              </div>
              <div>
              <Select
                    autoSelect={false}
                    label="Setor"
                    arrData={this.state.departments}
                    handleSelect={this.callBackDepartment}
                />
              </div>
              <div>
                <Select
                    autoSelect={false}
                    label="Status"
                    arrData={this.state.status}
                    handleSelect={this.callBackStatus}
                />
              </div>
              <div>
                <Select
                    autoSelect={false}
                    label="Máquinas"
                    arrData={this.state.machinesSelect}
                    handleSelect={this.callBackMachines}
                />
              </div>
            </div>
          </div>
          <div className="caption" id="caption">
                <ul>
                  <li><span id="verde">Verde</span> - Máquina produzindo</li>
                  <li><span id="laranja">Laranja</span> - Máquina Sem Operador / Sem ordem de produção</li>
                  <li><span id="cinza">Cinza</span> - Máquina desligada</li>
                  <li><span id="vermelho">Vermelho</span> - Máquina parada</li>
                  <li><span id="azul">Azul</span> - Parada programada</li>
                </ul>
          </div>   
          <div className="border menu-container" style={{ textAlign: "2vh" }}>
          <div className="machine-tracking-container" style={{alignItems:'center', justifyContent:'center'}}>
            { 
             loading ? (
             
                <div  className={styles.loader}>
                  <Spinner variant="success" animation="border" />
                  <strong>Carregando...</strong>
                </div>
            ) :
            Dashboard ? (
              <div className="machine-tracking-container" style={{alignItems:'center', justifyContent:'center'}}>
                
                {this.state.machines.map((item, index) => (
                  <div id={item.id}>
                    <CardMachine
                      id={item.id}
                      statusData={item.statusData}
                      oeeData={item.oeeData}
                      notifyAction={this.notifyAction}
                      machine={item.description + item.code}
                      oeeGoal={item.oee_goal}
                    />
                  </div>
                ))}
              </div>
            ) : (
                <div className="messageDash">
                  <h3>{this.state.messageDash}</h3>
                </div>
            )}
     
     </div>
     </div>
        </main>
        {<BottomBar dash={this.state.machines.length > 4 ? true : false} />}   
      </>
    );
  }
}

export default Main;